import { api } from "../../../axios";

export type ServerModel<T> = {
  id: number;
  type: string;
  attributes: T;
};

export type RoadCustomizations = {
  name: string;
  status: string;
  created_at: string; // ISO 8601
  updated_at: string;
};

type Pagination = {
  page: number;
  items: number;
  count: number;
  pages: number;
};

export type RoadCustomizationsResponse = {
  data: Array<ServerModel<RoadCustomizations>>;
  pagination: Pagination;
};

export interface RoadmapTableData {
  id: number;
  status: string;
  name: string;
  created_at: string;
  updated_at: string;
}

export const fetchRoadCustomizations = async (
  token: string,
  page: Number,
  perPage: Number,
  searchValue?: string,
  orderBy?: string,
  orderDirection?: string,
  filterBy?: string[]
): Promise<RoadCustomizationsResponse> => {
  const base = "bx_block_pricingcalculator/road_customizations";
  const params = new URLSearchParams({
    page: String(page),
    per_page: String(perPage),
  });

  if (searchValue) params.set("search", searchValue);
  if (orderBy) params.set("sort_by", orderBy);
  if (orderDirection) params.set("sort_direction", orderDirection);
  if (filterBy && filterBy.length > 0) {
    filterBy.forEach((status) => params.append("status[]", status));
  }

  const URL = `${base}?${params.toString()}`;
  const response = await api.get(
    URL,
    {
      headers: { token: token }
    }
  );

  return response.data;
};

export const deleteRoadCustomization = async (token: string, id: number, isPermanent?: boolean) => {
  const response = await api.delete(
    `bx_block_pricingcalculator/road_customizations/${id}${isPermanent ? '/delete_forever' : ''}`,
    {
      headers: { token: token }
    }
  );

  return response.data;
};

export const updateRoadmapStatus = async (
  token: string,
  id: number,
  status: string
) => {
  const response = await api.patch(
    `bx_block_pricingcalculator/road_customizations/${id}/update_status`,
    { status },
    {
      headers: { token: token }
    }
  );

  return response.data;
};

export const duplicateRoadmap = async (token: string, ids: [number]) => {
  const response = await api.post(
    `bx_block_pricingcalculator/road_customizations/duplicate_selected`,
    {
      roadmap_ids: ids
    },
    {
      headers: { token: token }
    }
  );

  return response.data;
};
